document.addEventListener('DOMContentLoaded', () => {
  const shareButtons = document.querySelectorAll('.share-button');

  shareButtons.forEach(button => {
    const details = button.querySelector('.share-button__dropdown');
    const toggle = button.querySelector('.share-button__toggle');
    const fallback = details.querySelector('.share-button__content');
    const closeButton = details.querySelector('.share-button__close');
    const copyButton = details.querySelector('.share-button__copy');
    const input = details.querySelector('.share-button__input');
    const message = details.querySelector('.share-button__message');

    // 初始化：确保刷新后关闭
    details.open = false;
    fallback.classList.add('hidden');

    // 点击 toggle 展开/收起
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      details.open = !details.open;
      fallback.classList.toggle('hidden');
    });

    // 点击空白处关闭
    document.addEventListener('click', (e) => {
      if (!button.contains(e.target) && details.open) {
        details.open = false;
        fallback.classList.add('hidden');
      }
    });

    // 复制链接功能
    if (copyButton) {
      copyButton.addEventListener('click', () => {
        input.select();
        navigator.clipboard.writeText(input.value).then(() => {
          message.textContent = 'Link copied to clipboard!';
          message.classList.remove('hidden');
          setTimeout(() => {
            message.classList.add('hidden');
          }, 2000);
        });
      });
    }

    // 关闭按钮
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        details.open = false;
        fallback.classList.add('hidden');
      });
    }
  });
});